import { AxiosResponse } from 'axios'
import {
  IGetUserResponseResult,
  IGetUserResponse,
  IResponseApplication,
  IResponseBonuses,
  IInitCallResponse,
  IVerificationCodeResponse
} from './../model/types'
import api from '~/services/api'

// Prime Hill
export const getUser = async (phone: string, session: number): Promise<IGetUserResponseResult> => {
  const { data }: AxiosResponse<IGetUserResponse> = await api.post('prime-hill/get-user', {
    phone,
    session: Number(session)
  })
  return data.result
}

export const application = async (phone: string, session: number, bonus: number) => {
  const { data }: AxiosResponse<IResponseApplication> = await api.post('prime-hill/application-loyalty', {
    phone,
    session,
    bonus
  })
  return data.result
}

export const receivingBonuses = async (transactionId: number) => {
  const { data }: AxiosResponse<IResponseBonuses> = await api.post('prime-hill/balance-bonus', {
    transaction_id: transactionId
  })
  return data.result
}

export const initCallPrimeHill = async (shopId: number, phone: string): Promise<boolean> => {
  const { data }: AxiosResponse<IInitCallResponse> = await api.post('prime-hill/init-call', {
    shop_id: shopId,
    phone
  })
  return data.success
}

export const verificationCodePrimeHill = async (shopId: number, phone: string, code: string): Promise<boolean> => {
  const { data }: AxiosResponse<IVerificationCodeResponse> = await api.post('prime-hill/verification-code', {
    shop_id: shopId,
    phone,
    code
  })
  return data.success
}

// iikoCard
export const getUserIikoCard = async (phone: string, session: number): Promise<IGetUserResponseResult> => {
  const { data }: AxiosResponse<IGetUserResponse> = await api.post('iiko-card/get-user', {
    phone,
    session: Number(session)
  })
  return data.result
}

export const applicationIikoCard = async (phone: string, session: number, bonus: number) => {
  const { data }: AxiosResponse<IResponseApplication> = await api.post('iiko-card/application-loyalty', {
    phone,
    session,
    bonus
  })
  return data.result
}

export const receivingBonusesIikoCard = async (transactionId: number) => {
  const { data }: AxiosResponse<IResponseBonuses> = await api.post('iiko-card/balance-bonus', {
    transaction_id: transactionId
  })
  return data.result
}
